import { createContext, useContext } from 'react'
import type { SectionLink } from '../lib/sections'

export type EditorialTitleContextValue = { section: SectionLink; publicationSlug: string }
export const EditorialTitleContext = createContext<EditorialTitleContextValue | null>(null)

/** False for a title outside SECTION_AGENT_PUBS: hide Start a piece and Draft now. */
export function useCanDraft(): boolean {
  const v = useContext(EditorialTitleContext)
  return v ? v.section.switched_on !== false : true
}

export function useEditorialTitle(): EditorialTitleContextValue {
  const v = useContext(EditorialTitleContext)
  if (!v) throw new Error('useEditorialTitle outside EditorialTitle')
  return v
}
